import React from 'react';
import { cn } from 'lib/utils';

interface FilterCardProps {
    label: string;
    count?: number;
    suffix?: string;            // 단위 (개/건/명)
    active: boolean;
    onClick: () => void;
}

/**
 * 클릭 가능한 필터 카드. 활성 상태는 navy-50 배경 + navy-100 보더 (보더 두께는 1px 유지 — DESIGN.md §4)
 */
const FilterCard: React.FC<FilterCardProps> = ({ label, count, suffix = '개', active, onClick }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                'flex flex-col gap-1 rounded border px-4 py-3 text-left transition-colors duration-fast',
                active
                    ? 'bg-navy-50 border-navy-100'
                    : 'bg-card border-border hover:border-neutral-300'
            )}
        >
            <span
                className={cn(
                    'text-xs font-medium leading-tight',
                    active ? 'text-primary' : 'text-muted-foreground'
                )}
            >
                {label}
            </span>
            {count !== undefined && (
                <span
                    className={cn(
                        'text-xl font-semibold leading-tight tracking-tight tabular-nums',
                        active ? 'text-primary' : 'text-foreground'
                    )}
                >
                    {count.toLocaleString()}
                    {suffix && (
                        <span className="ml-0.5 text-sm font-normal text-muted-foreground">
                            {suffix}
                        </span>
                    )}
                </span>
            )}
        </button>
    );
};

interface FilterCardGroupProps {
    children: React.ReactNode;
    columns?: number;
}

const columnClass: Record<number, string> = {
    2: 'grid-cols-2',
    3: 'grid-cols-2 sm:grid-cols-3',
    4: 'grid-cols-2 lg:grid-cols-4',
    5: 'grid-cols-2 lg:grid-cols-5',
};

export const FilterCardGroup: React.FC<FilterCardGroupProps> = ({ children, columns = 5 }) => (
    <div className={cn('mb-4 grid gap-3', columnClass[columns] || columnClass[5])}>
        {children}
    </div>
);

export default FilterCard;
